import { Directive, Input, HostListener, OnInit } from '@angular/core';
import { isNullOrUndefined } from './objectUtils';


//Implementação basica de uma directiva que limpa os campos relacionados
//Poderá existir a necessidade de que esta limpeza seja feita condicionalmente
//Terá que se averiguar essa situação no futuro (possivelmente receber uma lambda como input ou algo do género)

@Directive({
    selector: '[ngModel][clearRelated]',
    standalone: false
})
export class ClearRelatedFieldsDirective implements OnInit{
  @Input()
  clearRelated: ClearRelatedInput;
  @Input()
  clearOnlyOnReset: boolean;

  ngOnInit() {
    this.clearOnlyOnReset = this.clearOnlyOnReset !== undefined
  }

  @HostListener('ngModelChange', ['$event']) onModelChanges(event: any) {
    if (!isNullOrUndefined(this.clearRelated?.model) && !isNullOrUndefined(this.clearRelated?.propsToReset)) {
      Object.keys(this.clearRelated.model).forEach(controlKey => {
        if (this.clearRelated.propsToReset.findIndex(prop => prop == controlKey) != -1 &&
           (!this.clearOnlyOnReset || (isNullOrUndefined(event) && this.clearOnlyOnReset)))
            this.clearRelated.model[controlKey] = undefined;
        })
    }
  }
}

interface ClearRelatedInput {
  model: any,
  propsToReset : string[]
}
